// ---------------------------------------------------------------------------useReducer----------------------------------------------------------------------------------------------

// import React, { useReducer } from "react";

// function first(state, a) {
//   switch (a?.t) {
//     case "+":
//       if (state?.count === 5) {
//         return { ...state, count: state?.count, e: "u max the limit" };
//       } else {
//         return { ...state, count: state?.count + 1, e: "" };
//       }
//     case "-":
//       if (state?.count === 1) {
//         return { ...state, count: state?.count, e: "select min atleast 1" };
//       } else {
//         return { ...state, count: state?.count - 1, e: "" };
//       }
//     case "r":
//       return { ...state, count: 0, e: "" };
//     default:
//       return state;
//   }
// }

// function Demo() {
//   const [state, dispatch] = useReducer(first, { count: 0, e: "" });
//   return (
//     <>
//       <div style={{ display: "flex" }}>
//         {state?.count === 0 ? (
//           <button onClick={() => dispatch({ t: "+" })}>Add 2 Cart</button>
//         ) : (
//           <>
//             <button onClick={() => dispatch({ t: "-" })}>-</button>
//             <p>{state?.count}</p>
//             <button onClick={() => dispatch({ t: "+" })}>+</button>
//             <button onClick={() => dispatch({ t: "r" })}>Reset</button>
//           </>
//         )}
//       </div>
//       <p style={{ color: "red" }}>{state?.e}</p>
//     </>
//   );
// }

// export default Demo;

// ---------------------------------------------------------------------------useTransition----------------------------------------------------------------------------------------------
// import React, { useState, useTransition } from "react";

// const data = [
//   "Apple",
//   "Banana",
//   "Orange",
//   "Grapes",
//   "Watermelon",
//   "Pineapple",
//   "Blueberry",
//   "Strawberry",
//   "Mango",
//   "Lemon",
// ];
// const date = Array.from({ length: 40 }, (_, i) => i + 1);

// function FilterList() {
//   const [input, setinput] = useState("");
//   const [isPending, startTransition] = useTransition();
//   const [filtered, setFiltered] = useState(date);

//   function handlechange(e) {
//     const v = e.target.value;
//     setinput(v);
//     startTransition(() => {
//       const r = date.filter((i) =>
//         i.toString().toLowerCase().includes(v.toLowerCase())
//       );
//       setFiltered(r);
//     });
//   }

//   return (
//     <div>
//       <input type="text" value={input} onChange={handlechange} />
//       {/* <button onClick={handlechange}>search</button> */}
//       {isPending && <p>Loading...</p>}
//       <ul>
//         {filtered.map((it, i) => (
//           <li key={i}>{it}</li>
//         ))}
//       </ul>
//     </div>
//   );
// }

// export default FilterList;

// ---------------------------------------------------------------------------clgoddoreven----------------------------------------------------------------------------------------------
import { useState } from "react";

function NumberCheckerAllMethods() {
  const [values, setValues] = useState({ input: "", output: "" });

  function handleCheck() {
    const trimmed = values.input.trim();

    if (!trimmed) {
      setValues((pv) => ({ ...pv, output: "Please enter a number" }));
      return;
    }

    const num = Number(trimmed);
    if (isNaN(num)) {
      setValues((pv) => ({ ...pv, output: "Please enter a valid number" }));
      return;
    }

    // 1️⃣ Using if/else
    let ifElseEvenOdd = num % 4 === 0 ? "leap year" : "non leap year";
    let ifElsePosNegZero = num > 0 ? "POSITIVE" : num < 0 ? "NEGATIVE" : "ZERO";

    // 2️⃣ Using ternary operator (nested)
    let ternaryEvenOdd = num % 2 === 0 ? "EVEN" : "ODD";
    let ternaryPosNegZero =
      num > 0 ? "POSITIVE" : num < 0 ? "NEGATIVE" : "ZERO";

    // 3️⃣ Using switch case
    let switchEvenOdd = "";
    switch (num % 2) {
      case 0:
        switchEvenOdd = "EVEN";
        break;
      case 1:
      case -1:
        switchEvenOdd = "ODD";
        break;
    }

    let switchPosNegZero = "";
    switch (Math.sign(num)) {
      case 1:
        switchPosNegZero = "POSITIVE";
        break;
      case -1:
        switchPosNegZero = "NEGATIVE";
        break;
      case 0:
        switchPosNegZero = "ZERO";
        break;
    }

    // Combine all results
    const outputText = `
    You entered: ${num}
1️⃣ If/Else: ${ifElseEvenOdd} and ${ifElsePosNegZero}
2️⃣ Ternary: ${ternaryEvenOdd} and ${ternaryPosNegZero}
3️⃣ Switch: ${switchEvenOdd} and ${switchPosNegZero}
    `;

    setValues((pv) => ({ ...pv, input: "", output: outputText }));
  }

  return (
    <div>
      <h2>Number Checker (All Methods)</h2>
      <input
        type="text"  
        placeholder="Enter a number"
        value={values.input}
        onChange={(e) => setValues((pv) => ({ ...pv, input: e.target.value }))}
      />
      <button onClick={handleCheck}>Check</button>
      <pre>{values.output}</pre>
    </div>
  );
}

export default NumberCheckerAllMethods;
